/**
 * Stimulus controller that reloads the turbo-frame when it becomes visible in
 * the viewport.
 *
 * Usage:
 *
 *   <turbo-frame id="my-frame"
 *                src="/my-frame"
 *                data-controller="reload-on-visible">
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  /**
   * Initializes an IntersectionObserver when the controller connects.
   * The observer triggers `reload` on the element when it becomes visible in
   * the viewport.
   */
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.element.reload();
        }
      });
    }, {
      root: null, // use viewport as root
      threshold: 0.1 // percentage of the element that needs to be visible before callback is triggered
    });

    this.observer.observe(this.element);
  }

  /**
   * Disconnects the IntersectionObserver when the controller is disconnected.
   * This is necessary to clean up and avoid memory leaks.
   */
  disconnect() {
    if (this.observer) {
      this.observer.unobserve(this.element);
    }
  }
}
